import React, { useState } from "react";
import SignatureFormatter from "./components/SignatureFormatter";
import styled from "@emotion/styled";
import "./style.css";

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const Container = styled.div`
  width: 100%;
  display: block;
`;
const InputWrapper = styled.div`
  margin: 0 0;
  padding-top: 20px;
`;
const leftPart = {
  width: "100%"
}
const inputWrapper = {
  display: "flex",
  flexDirection: "row",
  gap: "15px"
}
const userData = {
  firstname: "Prénom",
  lastname: "Nom",
  urlImage: "",
  job: "Titre du poste",
  phone: "06 32 16 56 92",
  postalAdress: "11 Parvis de Rotterdam, 59777 Lille",
  email: "contact@slash-consulting.fr",
  linkedin: "linkedin.com",
  instagram: "instagram.com",
  slogan: "Créateurs d'opportunités pour nos talents"
};

export default function App() {
  const [user, setUser] = useState(userData);
  const [isChecked, setIsChecked] = useState(false);
  const [typeImage, setTypeImage] = useState('gif');
  const [gifChecked, setGifChecked] = useState(false);
  const [staticChecked, setStaticChecked] = useState(false);

  const handleGifChange = (event) => {
    setGifChecked(event.target.checked);
    setStaticChecked(false);
    setTypeImage(event.target.value);
  };

  const handleStaticChange = (event) => {
    setGifChecked(false);
    setStaticChecked(event.target.checked);
    setTypeImage(event.target.value);
  };

  const userInfoChange = e => {
    const { name, value } = e.target;
    setUser({ ...user, [name]: value });
  };

  function copyToClipboard() {
    let tableToCopy = document.querySelector('.wrapper-table')
    let range = document.createRange();
    range.selectNode(tableToCopy);
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(range);
    document.execCommand("copy");
    window.getSelection().removeAllRanges();
  }

  function responseCopy() {
    let button = document.querySelector('button');
      button.classList.add('copied');
    setTimeout(() => {
      button.classList.remove('copied');
    }, 2000);
  }

  return (
    <Wrapper>
      <Container>
        <section className="formulaire">
          <div style={leftPart}>
            <SignatureFormatter user={user} message={isChecked} typeImage={typeImage} />
          </div>
          <div className="rightPart">
            <h1 className="title">Signature Generator</h1>
            <h2 className="title">By my client is rich</h2>
            <p className="inputLabel">Noms</p>
            {/* ***************          NOM ET PRENOM        *************** */}
            <InputWrapper style={inputWrapper}>
              <input
                name="lastname"
                onChange={userInfoChange}
                value={user.lastname}
                placeholder="Nom"
                onBlur={() => {
                  user.lastname === "" ? setUser({ ...user, lastname: userData.lastname }) : setUser({ ...user, lastname: user.lastname });
                }}
                onFocus={() => {
                  user.lastname === userData.lastname ? setUser({ ...user, lastname: "" }) : setUser({ ...user, lastname: user.lastname });
                }}
              />
              <input
                name="firstname"
                onChange={userInfoChange}
                value={user.firstname}
                placeholder="Prénom"
                onBlur={() => {
                  user.firstname === "" ? setUser({ ...user, firstname: userData.firstname }) : setUser({ ...user, firstname: user.firstname });
                }}
                onFocus={() => {
                  user.firstname === userData.firstname ? setUser({ ...user, firstname: "" }) : setUser({ ...user, firstname: user.firstname });
                }}
              />
            </InputWrapper>
            {/* ***************          TITRE DU POSTE        *************** */}
            <InputWrapper>
              <input
                name="job"
                onChange={userInfoChange}
                value={user.job}
                placeholder="Titre du poste"
                onBlur={() => {
                  user.job === "" ? setUser({ ...user, job: userData.job }) : setUser({ ...user, job: user.job });
                }}
                onFocus={() => {
                  user.job === userData.job ? setUser({ ...user, job: "" }) : setUser({ ...user, job: user.job });
                }}
              />
            </InputWrapper>
            {/* ***************          MESSAGE        *************** */}
            <p className="inputLabel">Message</p>
            <InputWrapper>
              <textarea
                name="slogan"
                onChange={userInfoChange}
                value={user.slogan}
                type="textarea"
                placeholder="Message"
                onBlur={() => {
                  user.slogan === "" ? setUser({ ...user, slogan: userData.slogan }) : setUser({ ...user, slogan: user.slogan });
                }}
                onFocus={() => {
                  user.slogan === userData.slogan ? setUser({ ...user, slogan: "" }) : setUser({ ...user, slogan: user.slogan });
                }}
              />
            </InputWrapper>
            <p className="inputLabel">Coordonnées</p>
            {/* ***************          ADRESSE POSTALE        *************** */}
            <InputWrapper>
              <input
                name="postalAdress"
                onChange={userInfoChange}
                value={user.postalAdress}
                placeholder="Adresse postal"
                onBlur={() => {
                  user.postalAdress === "" ? setUser({ ...user, postalAdress: userData.postalAdress }) : setUser({ ...user, postalAdress: user.postalAdress });
                }}
                onFocus={() => {
                  user.postalAdress === userData.postalAdress ? setUser({ ...user, postalAdress: "" }) : setUser({ ...user, postalAdress: user.postalAdress });
                }}
              />
            </InputWrapper>
            {/* ***************          ADRESSE EMAIL        *************** */}
            <InputWrapper>
              <input
                name="email"
                onChange={userInfoChange}
                value={user.email}
                placeholder="Adresse email"
                onBlur={() => {
                  user.email === "" ? setUser({ ...user, email: userData.email }) : setUser({ ...user, email: user.email });
                }}
                onFocus={() => {
                  user.email === userData.email ? setUser({ ...user, email: "" }) : setUser({ ...user, email: user.email });
                }}
              />
            </InputWrapper>
            {/* ***************          TELEPHONE        *************** */}
            <InputWrapper>
              <input
                name="phone"
                onChange={userInfoChange}
                value={user.phone}
                placeholder="Téléphone"
                onBlur={() => {
                  user.phone === "" ? setUser({ ...user, phone: userData.phone }) : setUser({ ...user, phone: user.phone });
                }}
                onFocus={() => {
                  user.phone === userData.phone ? setUser({ ...user, phone: "" }) : setUser({ ...user, phone: user.phone });
                }}
              />
            </InputWrapper>
            <p className="inputLabel">Social</p>
            {/* ***************          LINKEDIN        *************** */}
            <InputWrapper>
              <input
                name="linkedin"
                onChange={userInfoChange}
                value={user.linkedin}
                placeholder="Linkedin"
                onBlur={() => {
                  user.linkedin === "" ? setUser({ ...user, linkedin: userData.linkedin }) : setUser({ ...user, linkedin: user.linkedin });
                }}
                onFocus={() => {
                  user.linkedin === userData.linkedin ? setUser({ ...user, linkedin: "" }) : setUser({ ...user, linkedin: user.linkedin });
                }}
              />
            </InputWrapper>
            {/* ***************          INSTAGRAM        *************** */}
            <InputWrapper>
              <input
                name="instagram"
                onChange={userInfoChange}
                value={user.instagram}
                placeholder="Instagram"
                onBlur={() => {
                  user.instagram === "" ? setUser({ ...user, instagram: userData.instagram }) : setUser({ ...user, instagram: user.instagram });
                }}
                onFocus={() => {
                  user.instagram === userData.instagram ? setUser({ ...user, instagram: "" }) : setUser({ ...user, instagram: user.instagram });
                }}
              />
            </InputWrapper>
            {/* ***************          IMAGE        *************** */}
            <p className="inputLabel">Image</p>
            {/* ***************          CENTRER IMAGE        *************** */}
            {/* <div className="checkItem">
              <input
                type="checkbox"
                id="topping"
                name="topping"
                value="Paneer"
                checked={isChecked}
                onChange={handleOnChange}
              />
            </div> */}
            {/* ***************          IMAGE STATIQUE OU GIF        *************** */}
            <div className="wrapperTypeImage">
              <div className="checkItem gif">
                <input
                  type="checkbox"
                  checked={gifChecked}
                  onChange={handleGifChange}
                  value="gif"
                />
              </div>
              <div className="checkItem static">
                <input
                  type="checkbox"
                  checked={staticChecked}
                  onChange={handleStaticChange}
                  value="static"
                />
              </div>
            </div>
            <button
              className="copyButton"
              onClick={() => {
                copyToClipboard();
                responseCopy();
              }}
            ><p className="btnCopy"></p></button>
          </div>
        </section>
      </Container>
    </Wrapper>
  );
}
